import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-search-dialog',
  templateUrl: './search-dialog.component.html',
  styleUrls: ['./search-dialog.component.css']
})
export class SearchDialogComponent implements OnInit {
  public headerText!: string;
  public inputLabel!: string;
  public result!: string;
  public inputForm: FormGroup = new FormGroup({
    ctrlInputText: new FormControl()
  });

  constructor(
    public dialogRef: MatDialogRef<SearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.headerText = this.data['headerText'];
    this.inputLabel = this.data['inputLabel'];
  }
  closeDialog() {
    this.result = '';
    this.dialogRef.close(this.result);
  }

  SaveData() {
    this.result = this.inputForm.controls['ctrlInputText'].value;
    if (this.result != '' && this.result != null) {
      this.dialogRef.close(this.result);
    }
  }
}
